import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Filter strings with digits",
  url: "filter-strings-with-digits",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {string[]} arr
* @return {string[]}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function filter(arr) {
  // your code goes here        
};
`,
};

export default info;
